import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import C from '../../../colors';

const NAV_ITEMS = [
  { id: 'watermark', to: '/user/setting/watermark', label: '水印设置', en: 'Watermark' },
  { id: 'tags',      to: '/user/setting/tag',        label: '标签设置', en: 'Tags' },
];

const SettingBar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div style={{ padding: '20px 36px 0', borderBottom: `1px solid ${C.hair}`, background: C.paper, display: 'flex', gap: 16, flexShrink: 0 }}>
      {NAV_ITEMS.map(it => {
        const on = location.pathname.startsWith(it.to);
        return (
          <button key={it.id} onClick={() => navigate(it.to)} style={{
            background: 'none', border: 'none', cursor: 'pointer',
            padding: '0 4px 12px', position: 'relative',
            fontFamily: C.sans, textAlign: 'left',
          }}>
            <div style={{ fontSize: 14, fontWeight: on ? 600 : 500, color: on ? C.ink : C.ink3, marginBottom: 2 }}>
              {it.label}
            </div>
            <div style={{ fontFamily: C.mono, fontSize: 9, letterSpacing: 1, color: C.ink3, textTransform: 'uppercase' }}>
              {it.en}
            </div>
            {on && <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 2, borderRadius: 1, background: C.brand }}/>}
          </button>
        );
      })}
    </div>
  );
};

export default SettingBar;
